import login from'./view/login'
import router from'./view/router'
import base from'./view/base/index.js'
import sportExercise from './view/sportExercise/index.js'
import sportTest from './view/sportTest/index.js'
import sportsGame from './view/sportsGame/index.js'
import sportEvaluation from './view/sportEvaluation/index.js'
import sportsTeach from'./view/sportsTeach/index.js'
import hm from'./view/hm/index.js'
import resources from'./view/resources/index.js'
import statisticsReport from './view/statisticsReport/index.js'

export default {
    router,
    views:{
        login,
        sportExercise,
        sportTest,
        sportsGame,
        base,
        sportEvaluation,
        sportsTeach,
        hm,
        resources,
        statisticsReport,
    },
    inputRequired:{
        '请填写登录用户名':'请填写登录用户名',
        '请填写登录密码':'请填写登录密码',
        '登录密码格式仅支持大小写字母、数字及特殊符号':'登录密码格式仅支持大小写字母、数字及特殊符号',
        '请填写验证码':'请填写验证码',
    },
    inputPlaceholder:{
        '请输入用户名（账号 或 手机号）':'请输入用户名（账号 或 手机号）',
        '请输入密码':'请输入密码',
        '请输入验证码':'请输入验证码',
        '名称/编码模糊搜索':'名称/编码模糊搜索',
    },
    from:{
        '全部':'全部',
        '类型':'类型',
        '状态':'状态',
        '请选择状态':'请选择状态',
        '性质':'性质',
        '搜索':'搜索',
        '重置':'重置',
        '查询':'查询',
        '新增':'新增',
        '启用':'启用',
        '停用':'停用',
        '查看':'查看',
        '数据':'数据',
        '编辑':'编辑',
        '删除':'删除',
        '保存':'保存',
        '操作':'操作',
        '下载':'下载',
        '备注':'备注',
        '返回':'返回',
        '其他':'其他',
        '租户':'租户',
        '机构':'机构',
        '请选择机构':'请选择机构',
        '联系方式':'联系方式',
        '邮箱':'邮箱',
        '创建人':'创建人',
        '创建时间':'创建时间',
        '更新时间':'更新时间',
        '基本信息':'基本信息',
        '区域':'区域',
        '详细地址':'详细地址',
        '扩展信息':'扩展信息',
        '机构LOGO':'机构LOGO',
        '平台LOGO':'平台LOGO',
        '域名':'域名',
        '通用':'通用',
        '项目':'项目',
        '项目名称':'项目名称',
        '项目ID':'项目ID',
        '项目状态':'项目状态',
        '知道了':'知道了',
        '页':'页',
        '条':'条',
        '共计{total}条数据':'共计{total}条数据',
        '取消':'取消',
        '下一步':'下一步',
        '上一步':'上一步',
        '确认':'确认',
        '确定':'确定',
        '保存成功！':'保存成功！',
        '发布范围':'发布范围',
        '请输入{name}':'请输入{name}',
        '请选择{name}':'请选择{name}',
        '分':'分',
        '秒':'秒',
        '个':'个',
        '次':'次',
        '已启用':'已启用',
        '已停用':'已停用',
        '启用':'启用',
        '停用':'停用',
        '成功':'成功',
        '失败':'失败',
        '男':'男',
        '女':'女',
        '等级':'等级',
        '暂无':'暂无',
        '结束':'结束',
        '重置密码':'重置密码',
        '批量移除':'批量移除',
        '批量新增':'批量新增',
        '移除':'移除',
        '全部选择':'全部选择',
        '平台':'平台',
        '点击查看大图':'点击查看大图',
        '排序':'排序',
        '发布':'发布',
        '序号':'序号',
        '上移':'上移',
        '下移':'下移',
        '学级':'学级',
        '请选择学级':'请选择学级',
        "院系":'院系',
        "专业":'专业',
        "请选择专业":'请选择专业',
        '班级':'班级',
        '年级':'年级',
        '应用终端':'应用终端',
        '请选择应用终端':'请选择应用终端',
        '场景':'场景',
        '请选择项目':'请选择项目',
        '运动时间':'运动时间',
        '运动时长':'运动时长',
        '姓名、学籍号模糊搜索':'姓名、学籍号模糊搜索',
        '姓名模糊搜索':'姓名模糊搜索',
        '视频回看':'视频回看',
        '视频预览':'视频预览',
        '所属机构':'所属机构',
        '性别':'性别',
        '学籍号':'学籍号',
        '锻炼时长':'锻炼时长',
        '测试时间':'测试时间',
        '成绩':'成绩',
        '出手':'出手',
        '出手次数':'出手次数',
        '命中':'命中',
        '对手':'对手',
        '胜负':'胜负',
        '比分':'比分',
        '胜利':'胜利',
        '平手':'平手',
        '运动时间':'运动时间',
        '学年':'学年',
        '请选择学年':'请选择学年',
        '（当前学年）':'（当前学年）',
        '学期':'学期',
        '请选择学期':'请选择学期',
        '（当前学期）':'（当前学期）',
        '秒':'秒',
        '批量导出':'批量导出',
        '姓名':'姓名',
        '得分':'得分',
        '分数':'分数',
        '管理':'管理',
        '批量操作':'批量操作',
        '批量导入':'批量导入',
        '标准分':'标准分',
        '附加分':'附加分',
        '用户名称':'用户名称',
        '评分标准':'评分标准',
        '违规':'违规',
        '照片':'照片',
        '已上传':'已上传',
        '未上传':'未上传',
        '姓名、准考证号模糊搜索':'姓名、准考证号模糊搜索',
        '准考证号':'准考证号',
        '报考项目':'报考项目',
        '用户名搜索':'用户名搜索',
        '全选（跨页）':'全选（跨页）',
        '学校':'学校',
        '教师':'教师',
        '手机号':'手机号',
        '账号':'账号',
        '用户':'用户',
        '关闭':'关闭',
        '更多':'更多',
        '上传':'上传',
        '所属项目':'所属项目',
        '清空':'清空',
        '视频':'视频',
        '修改':'修改',
        '不限':'不限',
        '认证':'认证',
        '运动报告':'运动报告',
        '详情':'详情',

        //25-8-1
        '操作成功':'操作成功',
        '场所':'场所',
        //25-12-19
        '民族':'民族',
        //26-1-7
        '有效':'有效',
        '自由锻炼':'自由锻炼',
        '微球场':'微球场',
        '应用终端':'应用终端',
        '竞技场':'竞技场',
        '趣味锻炼':'趣味锻炼',
        '是':'是',
        '否':'否',
        '时长':'时长',
        //26-6-16
        '运动结果':'运动结果',
        '达标状态':'达标状态',
        '已达标':'已达标',
        '未达标':'未达标',
        //26-7-7 阳光跑统计报表
        '时间':'时间',
        '日期':'日期',
        '周':'周',
        '月':'月',
        '自定义':'自定义',
        '总里程':'总里程',
        '平均配速':'平均配速',
        '人':'人',
        '参与率':'参与率',
        '导出报表':'导出报表',
        '请选择年级':'请选择年级',
    },
    udload:{
        '1、下载导入模版、填写信息':'1、下载导入模版、填写信息',
        '2、上传填写好的文件，导入数据':'2、上传填写好的文件，导入数据',
        '下载模板':'下载模板',
        '选择文件':'选择文件',
        '导入':'导入',
        '导出':'导出',
        '导出失败':'导出失败',
        '数据导入中':'数据导入中...',
        '下载失败记录':'下载失败记录',
        '重新上传':'重新上传',
        '导入完成':'导入完成',
        '导入成功！':'导入成功！',
        '导入失败！':'导入失败！',
        '数据导入成功！':'数据导入成功！',
        '数据导入失败！':'数据导入失败！',
        '失败记录':'失败记录',
        '只能导入Excel表格文件！':'只能导入Excel表格文件！',
        '文件上传成功！':'文件上传成功！',
        '文件格式不正确，请重新上传！':'文件格式不正确，请重新上传！',
        '上传中...':'上传中...',
        '上传中':'上传中...',
        '点击上传':'点击上传',
        '请上传文件':'请上传文件',
        '下载模版':'下载模版',
        '上传图片': '上传图片',
        '成绩导入完成':'成绩导入完成',
        '批量成绩导入失败列表':'批量成绩导入失败列表',
        '姓名,学籍号,失败原因':'姓名,学籍号,失败原因',
        '文件':'文件',
        '请选择运动员':'请选择运动员',
        '文件大小不符合规范！':'文件大小不符合规范！',
        '文件上传中':'文件上传中',
        '文件上传完成':'文件上传完成',
        '后台数据处理中，成绩导入完成预计3到5分钟（可关闭窗口，不影响导入）':'后台数据处理中，成绩导入完成预计3到5分钟（可关闭窗口，不影响导入）',
        '支持上传PNG、JPG格式图片，且图片小于5M':'支持上传PNG、JPG格式图片，且图片小于5M',
        '支持上传mp4格式，且视频小于2G':'支持上传mp4格式，且视频小于2G',
        '支持上传MP3格式，且音频小于20M':'支持上传MP3格式，且音频小于20M',
        '成绩数据导入处理完成':'成绩数据导入处理完成',
    },
    grd:{
        '一年级':'一年级',
        '二年级':'二年级',
        '三年级':'三年级',
        '四年级':'四年级',
        '五年级':'五年级',
        '六年级':'六年级',
        '初 一':'初 一',
        '初 二':'初 二',
        '初 三':'初 三',
        '高 一':'高 一',
        '高 二':'高 二',
        '高 三':'高 三',
        '大 一':'大 一',
        '大 二':'大 二',
        '大 三':'大 三',
        '大 四':'大 四',
    },
    message: {
        '是否返回': '是否返回',
        '是否返回上一页？': '是否返回上一页？',
        '数据保存成功！': '数据保存成功！',
        '新增成功': '新增成功',
        '服务器出错，请稍后重试': '服务器出错，请稍后重试',
        '状态更改成功': '状态更改成功',
        '修改成功': '修改成功',
        '删除成功': '删除成功',
        '取消后，页面数据不再保存':'取消后，页面数据不再保存',
        '操作成功': '操作成功',
        '返回后，页面数据不做保存': '返回后，页面数据不做保存',
        '确认要返回吗？': '确认要返回吗？',
        '请输入内容': '请输入内容',
        '内容文本已超过限制字数': '内容文本已超过限制字数',
        '链接不存在，请重新插入': '链接不存在，请重新插入',
        '链接必须以': '链接必须以 http/https 开头，请重新插入',
        '上传处理异常，请联系管理员': '上传处理异常，请联系管理员',
        '图片预览': '图片预览',
        '音频预览': '音频预览',
        '上传图片': '上传图片',
        '文件大小不符合规范！': '文件大小不符合规范！',
        '上传文件格式错误！': '上传文件格式错误！',
        '文件分辨率或大小超出范围！': '文件分辨率或大小超出范围！',
        '上传成功！': '上传成功！',

        '文件上传成功！': '文件上传成功！',
        '文件格式不正确，请重新上传！': '文件格式不正确，请重新上传！',
        '没有任何可用的角色权限信息，请联系管理员处理！':'没有任何可用的角色权限信息，请联系管理员处理！',
    }
};
